import React, { useEffect } from 'react';
import { Box, Grid, Paper } from "@material-ui/core";
import { connect } from "react-redux";
import { ApplicationState } from "../../redux/reducers";
import { ICliente } from "../../entities/catalogos/ICliente";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { IGuiaWizard } from "../../entities/guias/IGuiaWizard";
import { setGuiaWizard } from "../../redux/actions/guiaActions";
import { loadSucursales } from "../../redux/actions/sucursalActions";
import { useHistory } from "react-router-dom";
import HeaderGuia from "../header/HeaderGuia";
import OrigenDestinoGuia from "../origenDestino/OrigenDestinoGuia";
import DatosMercanciaGuia from "../datosMercancia/DatosMercanciaGuia";
import DatosServiciosGuia from "../servicioAdicional/DatosServiciosGuia";
import ResumenGuia from "../resumen/ResumenGuia";
import RevisionGuiaStep from "../resumen/RevisionGuiaStep";
import ConfirmacionGuiaStep from "../resumen/ConfirmacionGuiaStep";

interface StateProps {
    cliente: ICliente;
    usuario: IUsuario;
    guiaWizard: IGuiaWizard;
}

interface DispatchProps {
    setGuiaWizard: typeof setGuiaWizard;
    loadSucursales: typeof loadSucursales;
}

type Props = StateProps & DispatchProps;

const BodyGuia = ({ cliente, guiaWizard, loadSucursales }: Props) => {
    const history = useHistory();

    useEffect(() => {
        const esGuiasPortalExterno = localStorage.getItem("verGuiasPortalExterno");
        if (esGuiasPortalExterno !== "true") {
            history.push("/");
            return;
        }
        if (cliente?.empresaID > 0) {
            loadSucursales(cliente.empresaID);
        }
    }, [cliente?.empresaID]);

    let seccion: React.ReactNode;
    if (guiaWizard.seccionId === 1) {
        seccion = <OrigenDestinoGuia />;
    } else if (guiaWizard.seccionId === 2) {
        seccion = <DatosMercanciaGuia />;
    } else if (guiaWizard.seccionId === 3) {
        seccion = <DatosServiciosGuia />;
    } else if (guiaWizard.seccionId === 4 && !guiaWizard.createResult) {
        seccion = <RevisionGuiaStep />;
    } else if (guiaWizard.seccionId === 5 || guiaWizard.createResult) {
        seccion = <ConfirmacionGuiaStep />;
    } else {
        seccion = null;
    }

    const ocultarSidebarResumen = guiaWizard.seccionId === 4 || guiaWizard.seccionId === 5 || guiaWizard.createResult;

    return (
        <main>
            <HeaderGuia />
            <div style={{ width: '90%', margin: 'auto', marginTop: '2em' }}>
                <Grid container spacing={4}>
                    <Box clone order={{ xs: 2, md: 1 }}>
                        <Grid item xs={12} md={ocultarSidebarResumen ? 12 : 8}>
                            <Paper elevation={3}>
                                {seccion}
                            </Paper>
                        </Grid>
                    </Box>
                    {!ocultarSidebarResumen &&
                        <Box clone order={{ xs: 1, md: 2 }}>
                            <Grid item xs={12} md={4}>
                                <ResumenGuia />
                            </Grid>
                        </Box>
                    }
                </Grid>
            </div>
        </main>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario,
    guiaWizard: state.guiaWizard
});

const mapDispatchToProps = {
    setGuiaWizard,
    loadSucursales
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyGuia);
